<template>
  <v-navigation-drawer
    width="550px"
    absolute
    persistent
    color="var(--color-bg)"
  >
    <v-btn
      color="transparent"
      depressed
      class="back-button"
      @click="onBackButtonPressed"
      @mouseover="showBackButton = true"
      @mouseleave="showBackButton = false"
    >
      <v-icon
        left
        class="pa-0"
      >
        mdi-arrow-left
      </v-icon>
      {{ getBackButtonText }}
    </v-btn>

    <v-list class="component_margin">
      <v-list-item>
        <AreaDescriptionComponent />
      </v-list-item>
      <v-list-item>
        <AreaVertexCoordinatesComponent />
      </v-list-item>
    </v-list>

    <RequestResponseSnackBar
      v-model="showSuccessSnackBar"
      :value="showSuccessSnackBar"
      text="Area created successfully"
      color="green"
    />

    <RequestResponseSnackBar
      v-model="showErrorSnackBar"
      :value="showErrorSnackBar"
      text="Error in creating area"
      color="red"
    />

    <template v-slot:append>
      <div class="navigation_drawer_append">
        <CustomThemedButton
          :disabled="isSaveButtonDisabled"
          :loading="createCustomAreaLoading"
          class="create-area-button"
          rounded
          block
          @click="onCreateAreaPressed"
        >
          Create
        </CustomThemedButton>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import AreaDescriptionComponent from "./components/AreaDescription.vue";
import AreaVertexCoordinatesComponent from "./components/AreaVertexCoordinates.vue";
import RequestResponseSnackBar from "../../components/RequestResponseSnackBar.vue";
import CustomThemedButton from "../../../../core/CustomThemedButton.vue";
export default {
  name: "CreateArea",
  components: {
    AreaVertexCoordinatesComponent,
    AreaDescriptionComponent,
    RequestResponseSnackBar,
    CustomThemedButton,
  },
  data: function () {
    return {
      showBackButton: false,
      showSuccessSnackBar: false,
      showErrorSnackBar: false,
    };
  },
  computed: {
    ...mapGetters("weatherRouting/createCustomAreaModule", ["thereIsFeature"]),
    ...mapState("weatherRouting/createCustomAreaModule", [
      "createCustomAreaLoading",
      "createAreaFailed",
      "createAreaSuccess",
      "areaDescription",
    ]),
    getBackButtonText() {
      return this.showBackButton ? "Back" : "";
    },
    isSaveButtonDisabled() {
      return !this.thereIsFeature || this.areaDescription === "";
    },
  },
  watch: {
    createAreaFailed: {
      handler(value) {
        if (value) {
          this.showErrorSnackBar = true;
        }
      },
      deep: true,
    },
    createAreaSuccess: {
      handler(value) {
        if (value) {
          this.showSuccessSnackBar = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions("weatherRouting/createCustomAreaModule", [
      "createCustomArea",
    ]),
    ...mapActions("weatherRouting/customAreasModule", ["fetchAllAreas"]),
    async onCreateAreaPressed() {
      await this.createCustomArea();
    },
    async onBackButtonPressed() {
      this.$router.go(-1);
      this.$store.commit("weatherRouting/createCustomAreaModule/RESET_STATE", {
        root: true,
      });
      await this.fetchAllAreas();
    },
  },
};
</script>

  <style scoped>
.navigation_drawer_append {
  margin-top: 20px;
  margin-bottom: 35px;
  margin-left: 15px;
  margin-right: 15px;
}
.vuebar-element {
  height: 95%;
}
.area-new-view {
  background-color: var(--color-bg);
}
.back-button {
  background-color: var(--color-bg) !important;
  color: var(--color-text) !important;
}
.create-area-button {
  background-color: var(--color-secondary) !important;
  color: var(--color-text) !important;
}
.create-area-button:disabled {
  background-color: var(--color-secondary) !important;
  opacity: 0.5;
}
</style>
